import { isNil } from 'lodash';
import { CSSProperties, useState } from 'react';
import { Button } from '@shared/components/Button';
import { View } from '@shared/components/View';
import { Field } from '@shared/data/entity/fields/Field';
import { useWorkflowTemplate } from '@shared/scenes/workflows/hooks';
import { getAnchorName, grid } from '@shared/styles';
import { API } from '@shared/types/api';
import { useResponsiveFormContext } from '../ResponsiveFormContext';
import { SingleComponentForm } from './InputButtonForms/SingleComponentForm';

interface Props {
  component: API.InputButtonComponent;
  inputField: Field | null;
  workflowTemplateId: string;
  updateField: (componentId: string, field: Field | null) => void;
  style?: CSSProperties;
}

export function InputButtonEditField({
  component,
  inputField,
  workflowTemplateId,
  updateField,
  style,
}: Props) {
  const responsiveForms = useResponsiveFormContext();
  const anchorName = getAnchorName('input-button-edit', component.id);
  const [showForm, setShowForm] = useState(false);
  const workflowTemplate = useWorkflowTemplate(workflowTemplateId);

  const onClick = () => {
    setShowForm(prev => !prev);
  };

  return (
    <View
      style={{
        ...(!responsiveForms && styles.buttonContainer),
        ...(responsiveForms && styles.responsiveButtonContainer),
        ...style,
      }}
    >
      <Button
        variant="secondary"
        label={component.buttonText}
        numberOfLines={1}
        onClick={onClick}
        style={{ anchorName }}
        size="medium"
      />
      {showForm && !isNil(workflowTemplate.workflowTemplate) && (
        <SingleComponentForm
          fieldName={component.inputComponentId}
          field={inputField}
          anchorName={anchorName}
          workflowTemplate={workflowTemplate.workflowTemplate}
          onClose={() => setShowForm(false)}
          loading={workflowTemplate.loading}
          onUpdateField={updateField}
        />
      )}
    </View>
  );
}

const styles: Record<string, CSSProperties> = {
  buttonContainer: {
    paddingInline: grid(3),
    paddingBlock: grid(1.75),
  },
  responsiveButtonContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
};
